import React from 'react';

interface HelpBreadcrumbSchemaProps {
  slug: string;
  name: string;
}

/**
 * Emits a BreadcrumbList JSON-LD block for Help Center articles.
 * Home → Help Center → <article>. JSON.stringify keeps `&` and other
 * characters in `name` valid without manual escaping.
 */
const HelpBreadcrumbSchema: React.FC<HelpBreadcrumbSchemaProps> = ({ slug, name }) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://www.coderom.com/' },
          { '@type': 'ListItem', position: 2, name: 'Help Center', item: 'https://www.coderom.com/help' },
          { '@type': 'ListItem', position: 3, name, item: `https://www.coderom.com/help/${slug}` },
        ],
      }),
    }}
  />
);

export default HelpBreadcrumbSchema;
